import { render, staticRenderFns } from "./btn-text-primary3.vue?vue&type=template&id=03e5c37c&scoped=true&"
import script from "./btn-text-primary3.vue?vue&type=script&lang=js&"
export * from "./btn-text-primary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e5c37c",
  null
  
)

export default component.exports